import React from 'react';
import { TERRAIN } from '../content';
import { SCENE_IMG } from '../media';
export function Terrain() {
  return <section className="border-t border-border bg-card" aria-labelledby="terrain-heading" data-id="element-99" data-mp="2t8a7welt24f2">
      <div className="section-shell py-16 lg:py-20" data-id="element-100" data-mp="2y5afityazf8a">
        <p className="overline" data-id="element-101" data-mp="2y4h2xccnxvi8">The terrain</p>
        <h2 id="terrain-heading" className="mt-5 max-w-2xl font-serif text-h3 lg:text-h2" data-id="element-102" data-mp="32y3j3ei1chis">
          The climb is hard. You shouldn&rsquo;t make it alone.
        </h2>

        {/* Slim strip of alpine groundcover: the ground underfoot, literally. */}
        <figure className="m-0 mt-10 overflow-hidden rounded-lg" data-id="element-103" data-mp="3bzjk4vmyn7ac">
          <img src={SCENE_IMG.tundraSoil} alt="Red alpine groundcover spreading over lichen-covered rock" loading="lazy" className="block h-36 w-full object-cover object-center sm:h-44 lg:h-52" data-id="element-104" data-mp="3gxcmfdl57h5c" />
        </figure>

        <ol className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10" data-id="element-105" data-mp="1rh3jdxtcz0eq">
          {TERRAIN.map((item, i) => <li key={item.title} className="border-t border-border-strong pt-5" data-id="element-106" data-mp="37fm8tuons9e7" data-mpi={i}>
              <span className="text-body-sm text-accent-text" data-id="element-107" data-mp="32m9x2l52vx2v">0{i + 1}</span>
              <h3 className="mt-3 font-serif text-h4 leading-snug" data-id="element-108" data-mp="2xnovoie3b7cu">{item.title}</h3>
              <p className="mt-2 text-body-sm leading-body text-muted-foreground" data-id="element-109" data-mp="2sp5awlb8g1m2">{item.body}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}